import React from 'react'
import clsx from 'clsx';
import { 
  Phone, 
  Mail, 
  Help,
  CaretRight,
  Close
} from '../../common/icons'


function cta({languages, showModal, onCloseModal}) {
  return (
    <div className={clsx('modal-wrapper',
        {
        'd-none': !showModal
        })}
        >
        <div className='modal-overlay' onClick={onCloseModal}></div>
        <div className='modal'>
            <div className='modal-header py-3 px-2'>
            <p className='text-center modal-title'>{languages.ctaModalTitle ? languages.ctaModalTitle : 'What would you like to do?'}</p>
            <button 
                className='cta-close'
                onClick={onCloseModal}
            >
                <Close />
            </button>
            </div>         
            <div className='modal-body'>
            <ul className='holder-cta'>
                {/* <li className='cta'>
                <a className='cta-button' href=''>
                    <span className='mr-1'><Chat /></span>
                    Live chat
                    <span className='modal-caret'> <CaretRight /> </span>
                </a>
                </li> */}
                <li className='cta'>
                <a 
                    className='cta-button' 
                    href={languages.ctaCallbackLink ? languages.ctaCallbackLink : 'https://accorplushelp.zendesk.com/hc/en-au/requests/new?ticket_form_id=360002506493'}
                    target="_blank"
                >
                    <span className='mr-1'><Phone /></span> 
                    {languages.ctaCallback ? languages.ctaCallback : 'Request a call back'}
                    <span className='modal-caret'> <CaretRight /> </span>
                </a>
                </li>
                <li className='cta'>
                <a 
                    className='cta-button' 
                    href={languages.ctaMessageLink ? languages.ctaMessageLink : 'https://accorplushelp.zendesk.com/hc/en-au'}
                    target="_blank"
                >
                    <span className='mr-1'><Mail /></span>
                    {languages.ctaMessage ? languages.ctaMessage : 'Send a message'}
                    <span className='modal-caret'> <CaretRight /> </span>
                </a>
                </li>
                <li className='cta'>
                <a 
                    className='cta-button' 
                    href={languages.ctaFaqsLink ? languages.ctaFaqsLink : 'https://accorplus.com/about/faqs'}
                    target="_blank"
                >
                    <span className='mr-1 cta-help'><Help /></span> 
                    {languages.ctaFaqs ? languages.ctaFaqs : 'FAQs'}
                    <span className='modal-caret'> <CaretRight /> </span>
                </a>
                </li>
            </ul>
            </div>
        </div>
    </div>
  )
}

export default cta